<template>
  <section class="my-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="here px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">ショッピング会員登録申込完了</h3>
    <p class="mb-5">
      この度は、マナビス化粧品ショッピング会員登録にお申込みいただき、誠にありがとうございました。
    </p>
    <p class="">
      ショッピング会員登録手続き終了後、ご注文の商品を発送いたします。<br />
      今しばらくお待ちください。
      なお、物流の関係で商品の配達に数日かかる場合がございます。予めご了承願います。
    </p>
    
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>
<script>

import Store from "@/modules/Store";
let store = new Store();

export default {
  mounted() {
    window.scroll(0, 0);
    store.remove("serialMail");
  }
};

</script>